import React, { useContext, useState } from "react";
import {
  Col,
  Row,
  Button,
  Card
} from "react-bootstrap";
import Statics from "../Statics";
import { useParams } from "react-router-dom";
import ComponentContext from "../Context";
import DocumentMeta from "react-document-meta";
import HeaderBanner from "../Components/HeaderBanner";
import Kargah from "../Images/kargah.png";
export default () => {
  const { workshop_id } = useParams();
  const page_meta = {
    language: "fa",
    copyright: "پژوهیار",
    description: "نرم‌افزار استناددهی",
    title: "پرداخت | کارگاه",
    meta: {
      charset: "utf-8",
      name: {
        keywords: "پژوهیار"
      }
    }
  };

  const context = useContext(ComponentContext);
  const body = `به منظور فراگیریِ بهتر پژوهیار، دوره‌های آموزشی در سه سطح در نظر گرفته شده است. برای
      درخواست کارگاه و کلاس آموزشی از طریق فرم تربیت‌مدرس، فرم سازمانی و فرم عمومی ثبت نام فرمایید.`;
  const [loading_state, set_loading_state] = useState(Statics.NOT_LOADED);

  const [person, set_person] = useState({});
  const getRegisterationData = () => {
    set_loading_state(Statics.LOADING);
    context.ApiDriver.showRegisteredWorkshop(
      { id: workshop_id },
      data => {
        set_person(data);

        set_loading_state(Statics.LOADED);
      },
      error => {
        set_loading_state(Statics.CAUSED_ERROR);
      }
    );
  };
  const cancelRegisteration = () => {
    set_loading_state(Statics.LOADING);
    context.ApiDriver.cancelRegisteration(
      { id: workshop_id },
      data => {
        set_loading_state(Statics.LOADED);
        context.notification("ثبت نام با موفقیت لغو شد.", "success");
        window.location = '/workshop';
      },
      error => {
        set_loading_state(Statics.CAUSED_ERROR);
      }
    );
  };

  const generatePaylink = () => {
    // set_pay_loading_state(Statics.LOADING);
    context.ApiDriver.generatePaymentLink(
      { id: workshop_id },
      data => {
        console.log(data);
        window.location = data.link;
        // set_pay_loading_state(Statics.LOADED);
      },
      error => {
        // set_pay_loading_state(Statics.CAUSED_ERROR);
      }
    );
  };
  if (loading_state === Statics.NOT_LOADED) {
    getRegisterationData();
  }

  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner body={body} image={Kargah} header_color="#fdfbb1" />
      {loading_state === Statics.LOADED ? (
        <Row className="justify-content-center pt-5">
          <Col md={8}>
            <Row>
              <Card>
                <Card.Header>اطلاعات کارگاه</Card.Header>
                <Card.Body>
                  <Row>
                    <Col>
                      <Row>
                        <label>نام کارگاه:</label>
                        {"\u00A0"}
                        <lable>{person.workshop.title}</lable>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <label>توضیحات:</label>
                        {"\u00A0"}
                        <lable>{person.workshop.description}</lable>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <label>قیمت:</label>
                        {"\u00A0"}
                        <lable>{person.workshop.offered_fee}</lable>
                        <lable>ريال</lable>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <label>نوع کارگاه:</label>
                        {"\u00A0"}
                        <lable>{person.workshop.type.text}</lable>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      {person.workshop.meetings.data.length > 1 ? (
                        person.workshop.meetings.data.map((session, index) => (
                          <Row key={index}>
                            <p>
                              جلسه {index + 1}: {"\u00A0"}
                              <lable>
                                {session.start_date.year +
                                  "/" +
                                  session.start_date.month +
                                  "/" +
                                  session.start_date.day +
                                  "   " +
                                  session.start_date.hour +
                                  ":" +
                                  ("0" + session.start_date.minute).slice(-2)}
                              </lable>
                              {"\u00A0"}
                              {" تا "}
                              {"\u00A0"}
                              <lable>
                                {session.finish_date.hour +
                                  ":" +
                                  ("0" + session.finish_date.minute).slice(-2)}
                              </lable>
                            </p>
                          </Row>
                        ))
                      ) : person.workshop.meetings.data.length === 1 ? (
                        <Row>
                          <p>
                            جلسه 1: {"\u00A0"}
                            <lable>
                              {person.workshop.meetings.data[0].start_date
                                .year +
                                "/" +
                                person.workshop.meetings.data[0].start_date
                                  .month +
                                "/" +
                                person.workshop.meetings.data[0].start_date
                                  .day +
                                "   " +
                                person.workshop.meetings.data[0].start_date
                                  .hour +
                                ":" +
                                (
                                  "0" +
                                  person.workshop.meetings.data[0].start_date
                                    .minute
                                ).slice(-2)}
                            </lable>
                            {"\u00A0"}
                            {" تا "}
                            {"\u00A0"}
                            <lable>
                              {person.workshop.meetings.data[0].finish_date
                                .hour +
                                ":" +
                                (
                                  "0" +
                                  person.workshop.meetings.data[0].finish_date
                                    .minute
                                ).slice(-2)}
                            </lable>
                          </p>
                        </Row>
                      ) : (
                            ""
                          )}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Row>
            <Row className="pt-5">
              <Card>
                <Card.Header>اطلاعات فردی</Card.Header>
                <Card.Body>
                  <Row>
                    <Col>
                      <Row>
                        <label>نام:</label>
                        <lable>{person.first_name}</lable>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <label>نام‌خانوادگی:</label>
                        <lable>{person.last_name}</lable>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <label>تاریخ تولد:</label>
                        <lable>{person.birth_date}</lable>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <label>کدملی:</label>
                        <lable>{person.id_number}</lable>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <label>رشته:</label>
                        <lable>{person.field}</lable>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <label>مقطع:</label>
                        <lable>{person.grade}</lable>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <label>دانشگاه:</label>
                        <lable>{person.university}</lable>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <label>شغل:</label>
                        <lable>{person.job}</lable>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label>آدرس:</label>
                      <lable>{person.address}</lable>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Row>
            {person.status.code === 3 ? (<><Row className="pt-3 pb-3 justify-content-center">
                  <Button variant="success">
        شما از این کارگاه انصراف داده‌اید
           </Button>
                </Row>
              </>) :
              person.status.code === 1 && (person.workshop.status.code === 3 || person.workshop.status.code === 5) ? (<Row className="pt-3 pb-3 justify-content-around">
                {" "}
                <Button
                  variant="success"
                  onClick={() => {
                    generatePaylink();
                  }}
                >
                  پرداخت
           </Button>
                <Button
                  variant="danger"
                  onClick={() => {
                    cancelRegisteration();
                  }}
                >
                  انصراف
           </Button>
              </Row>) :
                person.status.code === 1 && person.workshop.status.code === 2 ? (<><Row className="pt-3 pb-3 justify-content-center">
                  <Button variant="success">
                    با تشکر از ثبت نام شما، درصورت تشکیل کارگاه از طریق پست
                    الکترونیکی با شما تماس خواهیم گرفت.
           </Button>
                </Row>
                  <Row className="pt-3 pb-3 justify-content-center">
                    <Button
                      variant="danger"
                      onClick={() => {
                        cancelRegisteration();
                      }}
                    >
                      انصراف
           </Button>
                  </Row></>) :
                  person.status.code === 1 && person.workshop.status.code === 6 ? "شما از این کارگاه انصراف داده‌اید" :
                    person.status.code === 2 && (person.workshop.status.code === 3 || person.workshop.status.code === 5) ? "هزینه کارگاه پرداخت شده و در در تاریخ اعلام شده کارگاه برگزار خواهد شد." :
                      person.status.code === 2 && person.workshop.status.code === 6 ? "کارگاه کنسل شده لطفا جهت عودت هزینه با پشتیبانی تماس بگیرید" : ""}

            {/* {person.workshop.status.code === 2 ? (
              <>
                <Row className="pt-3 pb-3 justify-content-center">
                  <Button variant="success">
                    با تشکر از ثبت نام شما، درصورت تشکیل کارگاه از طریق پست
                    الکترونیکی با شما تماس خواهیم گرفت.
                  </Button>
                </Row>
                <Row className="pt-3 pb-3 justify-content-center">
                  <Button
                    variant="danger"
                    onClick={() => {
                      cancelRegisteration();
                    }}
                  >
                    انصراف
                  </Button>
                </Row>
              </>
            ) : person.workshop.status.code === 3 ? (
              <Row className="pt-3 pb-3 justify-content-around">
                {" "}
                <Button
                  variant="success"
                  onClick={() => {
                    generatePaylink();
                  }}
                >
                  پرداخت
                </Button>
                <Button
                  variant="danger"
                  onClick={() => {
                    cancelRegisteration();
                  }}
                >
                  انصراف
                </Button>
              </Row>
            ) : (
                  ""
                )} */}

            {/* :""} */}
          </Col>
        </Row>
      ) : (
          ""
        )}
    </DocumentMeta>
  );
};
